<template>
  <div class="absolute p-2 top-0 right-0 bottom-0 flex items-center justify-between gap-2" >
    <i v-if="model && (typeof model !== 'string')" class="fa fa-check text-green-600/30" />
    <i v-else-if="model === null" class="fa fa-spinner fa-spin text-gray-600/30" />
    <i v-else-if="model === false" class="fa fa-times text-red-600/30" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  validation: (newVal: any, oldVal: any, bagging: any) => any|Promise<any>
  value: string|null|undefined
  validation_delay?: number
  isVirgin?: boolean
  onlyError?: boolean
}>()

const model = defineModel<boolean|null|undefined|string>()
const modelMessage = defineModel<string|null|undefined>('message')

onMounted(() => {
  model.value = null
  methodValidate(props.value, undefined, 0)
})

const methodValidate = (
  newVal: any|undefined,
  oldVal: any|undefined,
  force_delay: number|null = null
) => {
  new Promise((resolve, reject) => {
    setTimeout(async () => {
      if(props.value !== newVal) {
        return reject()
      }

      const bag: any = []

      const bagging = (value: any) => {
        bag.push(value)
      }

      modelMessage.value = null;
      let r = props.validation(newVal, oldVal, bagging)

      // if r is a promise or awaitable, await its resolution or error
      if (r instanceof Promise) {
        model.value = null;
        r = r.catch((e: any) => {
          console.info('Got error', e);
          bagging(e?.message ?? e);
        }).then((message) => {
          modelMessage.value = message;
          return true;
        })
        await r
      }

      if(bag?.length) {
        modelMessage.value = bag;
        model.value = false;
        return reject(bag)
      }

      if (
        props.value !== newVal
        || typeof r === 'string'
        || (Array.isArray(r) && r.some((v) => typeof v === 'string'))
      ) {
        modelMessage.value = r;
        model.value = false;
        return reject(false)
      }

      resolve(r ?? true)
    }, force_delay ?? props.validation_delay ?? 0)
  }).then((v) => {
    if(props.onlyError && v === true){
      return model.value = 'hidden'
    }

    model.value = v as boolean
  }).catch(() => {})
}

watch(() => props.value, (newVal, oldVal) => methodValidate(newVal, oldVal))
</script>
